/**
 * In-memory file transfer between routes.
 *
 * Used by PhotoToOrderPanel to pass a selected file to the /list page
 * without serialization (avoids sessionStorage quota limits for large
 * files). Works because wouter does client-side routing — the JS module
 * stays alive across route changes.
 */

let pendingFile: File | null = null;

export function setPendingFile(file: File) {
  pendingFile = file;
}

export function consumePendingFile(): File | null {
  const file = pendingFile;
  pendingFile = null;
  return file;
}
